import defaultTheme from "tailwindcss/defaultTheme";

const config = {
  content: [
    "./index.html",
    "./src/**/*.{jsx,tsx}",
    "../packages/component-library/**/*.{jsx,tsx}",
  ],
  theme: {
    extend: {
      fontSize: {
        base: "0.95rem",
      },
      colors: {
        primary: "var(--color-primary)",
        "primary-contrast": "var(--color-text-primary-contrast)",
        "text-primary": "var(--color-text-primary)",
        primaryHover: "var(--color-primary-hover)",
        error: "#D32F2F",
        background: "var(--background)",
        foreground: "var(--foreground)",
        gray: {
          50: "#FAFAFA",
          100: "#F5F5F5",
          200: "#EEEEEE",
          300: "#E0E0E0",
          400: "#BDBDBD",
          500: "#9E9E9E",
          600: "#757575",
          700: "#616161",
          800: "#424242",
          900: "#212121",
        },
      },
      backgroundImage: {
        mobile: "linear-gradient(to bottom, var(--bg-mobile-from), #F0F5F9)",
        desktop:
          "linear-gradient(to bottom right, var(--bg-desktop-from), #F0F5F9)",
      },
      fontFamily: {
        opensans: "OpenSans",
        montserrat: "Montserrat",
        sans: ["opensans", ...defaultTheme.fontFamily.sans],
      },
      boxShadow: {
        "responsive-card": "0 0 12px 0 rgba(0, 0, 0, 0.25)",
      },
    },
  },
  plugins: [],
};
export default config;
